import Em from 'ember';
export default Em.Component.extend({
  tagName: 'button',
  classNames: ['composer-media-selector-option', 'button-bare', 'call-to-action', 'composer-inserter'],
  classNameBindings: ['inserter-class-name'],
  click() {
    this.get('selectInserter')(this);
  }
});